export default __webpack_public_path__ + "static/media/link.93cca526.svg";